import PopupBanner from "@magoosh/lib/popup_banner/template";

export default PopupBanner;
